const hiddenProductCache = new Map();

function getProductHandle(url) {
  const match = String(url || '').match(/\/products\/([^/?#]+)/);
  return match ? decodeURIComponent(match[1]).toLowerCase() : '';
}

function productHideUrl(handle) {
  const root = window.Shopify?.routes?.root || '/';
  return `${root}products/${encodeURIComponent(handle)}?view=product-hide-json`;
}

async function isHiddenProduct(handle) {
  if (!handle) return false;
  if (hiddenProductCache.has(handle)) return hiddenProductCache.get(handle);

  const request = fetch(productHideUrl(handle), {
    headers: { Accept: 'application/json' },
    credentials: 'same-origin',
  })
    .then((response) => (response.ok ? response.json() : { hidden: false }))
    .then((data) => data.hidden === true)
    .catch(() => false);

  hiddenProductCache.set(handle, request);
  return request;
}

function removeEmptyResultPanel(result) {
  if (!result.querySelector('[data-search-result]')) {
    result.innerHTML = '';
    result.style.display = 'none';
  }
}

async function pruneHiddenProducts(result) {
  result.style.display = '';

  const items = Array.from(result.querySelectorAll('a[data-search-result][href*="/products/"]'));
  await Promise.all(
    items.map(async (item) => {
      if (item.dataset.productHideChecked === 'true') return;

      item.style.visibility = 'hidden';
      const handle = getProductHandle(item.getAttribute('href'));
      if (!(await isHiddenProduct(handle))) {
        item.dataset.productHideChecked = 'true';
        item.style.visibility = '';
        return;
      }

      const productBlock = item.closest('.xo-predictive-search-base__product');
      item.remove();

      if (productBlock && !productBlock.querySelector('a[data-search-result]')) {
        productBlock.remove();
      }
    }),
  );

  removeEmptyResultPanel(result);
}

function initPredictiveSearchHideProducts() {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      const result = mutation.target.closest?.('[data-predictive-search-result], [data-predictive-search-drawer-result]')
        || (mutation.target.matches?.('[data-predictive-search-result], [data-predictive-search-drawer-result]') ? mutation.target : null);

      if (result) pruneHiddenProducts(result);
    });
  });

  document
    .querySelectorAll('[data-predictive-search-result], [data-predictive-search-drawer-result]')
    .forEach((result) => observer.observe(result, { childList: true, subtree: true }));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPredictiveSearchHideProducts);
} else {
  initPredictiveSearchHideProducts();
}
